import {
    NavLink as ReactRouterNavLink,
    NavLinkProps as ReactRouterNavLinkProps,
} from 'react-router-dom';
import { brandColors, productColors } from '@givebutter/util';
import styled, { StyledProps, css } from 'styled-components';

interface NavTabProps {
    $useMarker?: boolean;
    disabled?: boolean;
}

interface NavLinkProps extends ReactRouterNavLinkProps, NavTabProps {}

const MarkerStyles = (props: StyledProps<NavTabProps>) => {
    return (
        props.$useMarker &&
        css`
            &.active::before,
            &[data-state='active']::before {
                top: 4px;
                bottom: 4px;
                left: 4px;
                width: 4px;
                content: '';
                position: absolute;
                border-radius: ${props => props.theme.radius.default};
                background: ${brandColors.cobalt.primary};
            }
        `
    );
};

const DisabledStyles = (props: StyledProps<NavTabProps>) => {
    return (
        props.disabled &&
        css`
            opacity: 0.3;
            pointer-events: none;
        `
    );
};

const NavTabStyles = css`
    border: 0;
    font-weight: 500;
    border-radius: ${props => props.theme.radius.default};
    padding: 0.625rem 1rem;
    position: relative;
    color: #222;
    outline: none !important;
    cursor: pointer;

    &:hover {
        color: ${brandColors.cobalt.primary};
        transition: none;
    }

    &.active,
    &[data-state='active'] {
        color: ${brandColors.cobalt.primary};
        background: ${productColors.neutral[25]};
    }

    ${MarkerStyles};
    ${DisabledStyles};
`;

const NavLink = styled(ReactRouterNavLink)<NavTabProps>`
    ${NavTabStyles};
`;

const MarkableNavLink = styled(NavLink).attrs({ $useMarker: true })``;

export { NavLink, NavTabStyles, MarkableNavLink };
export type { NavLinkProps };
